/**
 * Enum representing the task category codes
 * https://github.com/u21/ai-investigations-service/blob/master/ai_investigations_service/agents/constants.py#L94-#L106
 *
 */
export enum TaskCategory {
  ACCOUNT_RISK_SIGNAL_AGENT = 'ara',
  ONLINE_RESEARCH_SIGNAL_AGENT = 'ora',
  EVENT_ANALYSIS_SIGNAL_AGENT = 'eaa',
  FLAGGED_ACTIVITY_SIGNAL_AGENT = 'paa',
  NETWORK_INSIGHTS_SIGNAL_AGENT = 'nia',
  SANCTIONS_SIGNAL_AGENT = 'sa',
  FINCEN_SIGNAL_AGENT = 'fsa',
  USER_DEFINED_TASK = 'udt',
}
